// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/js/flexible_css.debug.js'
import './assets/js/flexible.debug.js'
import Overlay from 'vant/lib/overlay'
import 'vant/lib/overlay/style'
import '@vant/touch-emulator'

import 'viewerjs/dist/viewer.css'
Vue.use(Overlay)
Vue.config.productionTip = false
import vViewer from './directives/v-viewer' // 假设你的指令文件在directives目录下
Vue.directive('viewer', vViewer)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js